var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockCheckpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E9F6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_541_49853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3335 27.5417V26.2083C41.3335 23.733 40.3502 21.359 38.5999 19.6087C36.8495 17.8583 34.4756 16.875 32.0002 16.875C29.5248 16.875 27.1509 17.8583 25.4005 19.6087C23.6502 21.359 22.6669 23.733 22.6669 26.2083V27.5417H18.6669V44.875C18.6669 45.9359 19.0883 46.9533 19.8384 47.7034C20.5886 48.4536 21.606 48.875 22.6669 48.875H41.3335C42.3944 48.875 43.4118 48.4536 44.162 47.7034C44.9121 46.9533 45.3335 45.9359 45.3335 44.875V27.5417H41.3335ZM25.3335 26.2083C25.3335 24.4402 26.0359 22.7445 27.2862 21.4943C28.5364 20.244 30.2321 19.5417 32.0002 19.5417C33.7683 19.5417 35.464 20.244 36.7142 21.4943C37.9645 22.7445 38.6669 24.4402 38.6669 26.2083V27.5417H25.3335V26.2083ZM42.6669 44.875C42.6669 45.2286 42.5264 45.5678 42.2763 45.8178C42.0263 46.0679 41.6872 46.2083 41.3335 46.2083H22.6669C22.3132 46.2083 21.9741 46.0679 21.7241 45.8178C21.474 45.5678 21.3335 45.2286 21.3335 44.875V30.2083H42.6669V44.875Z",
    fill: "#2B6CB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3336 35.541H30.6669V40.8743H33.3336V35.541Z",
    fill: "#2B6CB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_541_49853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16.875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCheckpoint);
export default __webpack_public_path__ + "static/media/lockCheckpoint.817fb3b131c8f48f7708142a2da493fd.svg";
export { ForwardRef as ReactComponent };